// TabsAtom.tsx
import React, { useState } from "react";
// ASSETS

// STYLES
import {
  FiltersWrapper,
  HeaderCell,
  HeaderTabwrapper,
  TabWrapper,
} from "./HeaderTabStyled";

// LIBRARIES

import { useMediaQuery } from "react-responsive";

// MISC
import { CalendarType } from "components/Atoms/CalendarFilter/CalendarFilterModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { Filters, HeaderTabTypes, IProps } from "./HeaderTabModel";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CalendarFilter from "components/Atoms/CalendarFilter/CalendarFilter";
import CustomText from "components/Atoms/CustomText/CustomText";
import SelectInputFilter from "components/Atoms/SelectInputFilter/SelectInputFilter";
import MobileCalendarFilters from "components/MobileCalendarFilters/MobileCalendarFilters";

const HeaderTab: React.FC<IProps> = ({
  tabs,
  onTabSelect,
  selectedTabId,
  type = HeaderTabTypes.RedTheme,
  hasFilters,
  filtersContent,
  month = 0,
  year = 0,
  setMonth,
  setYear,
  checkedState,
  setCheckedState,
}) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const isMobile = useMediaQuery({ maxWidth: 1400 });

  // STATE CONSTANTS
  const [internalSelectedTab, setSelectedTab] = useState<number>(0);
  const selectedTab = selectedTabId ?? internalSelectedTab;

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const handleTabClick = (tabId: number) => {
    setSelectedTab(tabId);
    onTabSelect(tabId);
  };

  return (
    <HeaderTabwrapper type={type} hasFilters={hasFilters} $customFilters={Boolean(filtersContent)}>
      <TabWrapper>
        {tabs.map((tab, index) => {
          const isSelected = selectedTab === tab.id;
          return (
            <HeaderCell
              type={type}
              key={index}
              biggerCursor={biggerCursor}
              isSelected={isSelected}
              hasFilters={hasFilters}
              $compact={Boolean(filtersContent)}
              onClick={() => handleTabClick(tab.id)}
            >
              {tab.tabTitle.split("\n").map((line, index) => (
                <CustomText key={index} text={line} type={TextType.H6} />
              ))}
            </HeaderCell>
          );
        })}
      </TabWrapper>

      {filtersContent}
      {!filtersContent && hasFilters &&
        (!isMobile ? (
          <FiltersWrapper>
            {tabs[selectedTab].filtersType === Filters.present && (
              <>
                <SelectInputFilter
                  checkedState={checkedState}
                  setCheckedState={setCheckedState}
                />
                <CalendarFilter
                  type={CalendarType.month}
                  month={month}
                  year={year}
                  setMonth={setMonth}
                  setYear={setYear}
                />
              </>
            )}
            {tabs[selectedTab].filtersType === Filters.past && (
              <>
                <SelectInputFilter
                  checkedState={checkedState}
                  setCheckedState={setCheckedState}
                />
                <CalendarFilter
                  type={CalendarType.month}
                  month={month}
                  year={year}
                  setMonth={setMonth}
                  setYear={setYear}
                />
                <CalendarFilter
                  type={CalendarType.year}
                  month={month}
                  year={year}
                  setMonth={setMonth}
                  setYear={setYear}
                />
              </>
            )}
          </FiltersWrapper>
        ) : (
          <MobileCalendarFilters
            type={
              tabs[selectedTab].filtersType === Filters.present
                ? Filters.present
                : Filters.past
            }
            month={month}
            year={year}
            setMonth={setMonth}
            setYear={setYear}
            checkedState={checkedState}
            setCheckedState={setCheckedState}
          />
        ))}
    </HeaderTabwrapper>
  );
};

export default HeaderTab;
